// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2iFeM","content":"LayoutSettings_content__2BxPt"};